define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function loadStyleSheets(links) {
        var total = links.length;
        var linkElements = $.map(links, function (href) {
            var link = document.createElement("link");
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = href;
            link.onload = function () {
                total--;
                if (total === 0) {
                    $('body').trigger('styleSheetsLoaded', links);
                    $('.pending-css').toggleClass('pending-css', false);
                }
            };
            document.body.appendChild(link);
            return link;
        });
    }
    exports["default"] = loadStyleSheets;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/loadStyle.js
// module id = 85
// module chunks = 0